import styled from "@emotion/styled/macro"
import { PropsWithChildren, ReactElement } from "react"
import { colors } from "../config/theme"

const Box = styled.div`
  position: absolute;
  white-space: nowrap;
  top: 30px;
  left: -5px;
  visibility: hidden;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px;
  gap: 8px;

  color: ${colors.white};
  background: ${colors.black};
  border-radius: 2px;

  font-family: "Arial";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.02em;
  user-select: none;
`

const Base = styled.div`
  position: relative;
  &:hover > ${Box} {
    visibility: visible;
  }
`

export const Tooltip: React.FC<
  PropsWithChildren<{ content: ReactElement }>
> = ({ children, content }) => {
  return (
    <Base>
      <Box>{content}</Box>
      {children}
    </Base>
  )
}
